import { render, staticRenderFns } from "./settingsGeneral.vue?vue&type=template&id=342e41fa&"
import script from "./settingsGeneral.vue?vue&type=script&lang=ts&"
export * from "./settingsGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports